<div class="container single-view" id="view-category">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/categories" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CATEGORIES.BTN_BACK_TO_CATEGORY' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="category-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{
            'CATEGORY_SINGLE_VIEW.CATEGORY_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (category.name) {
                  <span data-testid="category-name">{{ category.name | defaultValue }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyCategory) {
              <button data-testid='category-edit-btn' id="btn-edit-category"
                class="btn primary-btn" (click)="goToEditCategory()">{{ 'CATEGORY_SINGLE_VIEW.BTN_EDIT' | translate
              }}</button>
            }
            @if (delete) {
              <button data-testid='category-delete-btn' id="btn-delete-category" class="btn red-btn"
              (click)="showDeleteDialog()">{{'CATEGORIES.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid='category-details'>{{ 'CATEGORY_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">
                  <dt data-testid='category-name-label' class="label grid-cols-1 pt-3">{{ 'CATEGORY_SINGLE_VIEW.NAME' |
                  translate }}</dt>
                  <dd data-testid='category-name' class="value pt-3 pb-3">{{ category.name | defaultValue }}</dd>

                  <dt data-testid='category-code-label' class="label grid-cols-1 pt-3">{{ 'CATEGORY_SINGLE_VIEW.CODE' |
                  translate }}</dt>
                  <dd data-testid='category-code' class="value pt-3 pb-3">{{ category.code | defaultValue }}</dd>

                  <dt data-testid='category-hasparent-label' class="label grid-cols-1 pt-3">{{
                  'CATEGORY_SINGLE_VIEW.HAS_PARENT' | translate }}</dt>
                  <dd data-testid='category-hasparent' class="value pt-3 pb-3">{{ (category.parent ? 'BOOLEANS.YES' :
                  'BOOLEANS.NO') | translate }}</dd>

                  @if (category.parent) {
                    <dt data-testid='category-parent-label' class="label grid-cols-1 pt-3">{{
                    'CATEGORY_SINGLE_VIEW.PARENT_NAME' | translate }}</dt>
                    <dd class="value pt-3 pb-3">
                      @if (category.parent.id) {
                        <a [routerLink]="['/categories/', category.parent.id]" data-testid='category-parent-category' class="inline-flex items-center link">{{ category.parent.name }}</a>
                      } @else {
                        {{ category.parent.name | defaultValue }}
                      }
                    </dd>
                    <dt data-testid='category-parent-code-label' class="label grid-cols-1 pt-3">{{
                    'CATEGORY_SINGLE_VIEW.PARENT_CODE' | translate }}</dt>
                    <dd data-testid='category-parent-code' class="value pt-3 pb-3">{{ category.parent.code | defaultValue }}</dd>
                  }
                </dl>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete category -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_CATEGORY'" (onClose)="deleteCategory($event)"></dialog-reason>
